import { matchPath } from "react-router-dom";
import { reportError } from "@bookingcom/flights-core";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { clientFetch } from "@flights/client-fetch";
import routeMap from "../routes.js";
export function createHandleClientRenderingError(globalContext) {
    return function handleClientRenderingError(error) {
        const route = routeMap({
            isMobile: globalContext?.userAgent?.isMobile,
            isNewFlightDetailsPage: !!globalContext?.isNewFlightDetailsPage,
            isNewFlightDetailsDesktopPage: !!globalContext?.isNewFlightDetailsDesktopPage,
            isPaymentCollectionPage: !!isFeatureRunningClientSide("FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE"),
            isWebview: globalContext?.userAgent?.isWebview
        }).find((route) => matchPath(window.location.pathname, { path: route.path, exact: true }));
        if (route?.name === "home") {
            const errorWithData = {
                ...error,
                title: "Home page unhandled error on client",
                isMobile: globalContext.userAgent.isMobile,
                isTablet: globalContext.userAgent.isTablet,
                isWebview: globalContext.userAgent.isWebview,
                isInternal: globalContext.isInternal,
                isBot: globalContext.userAgent.isBot,
                isKnownBot: globalContext.isKnownBot
            };
            reportError(errorWithData, "home");
        }
    };
}
export function createOnHydrationError(globalContext) {
    return function onHydrationError(error) {
        const route = routeMap({
            isMobile: globalContext?.userAgent?.isMobile,
            isNewFlightDetailsPage: !!globalContext?.isNewFlightDetailsPage,
            isNewFlightDetailsDesktopPage: !!globalContext?.isNewFlightDetailsDesktopPage,
            isPaymentCollectionPage: !!isFeatureRunningClientSide("FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE"),
            isWebview: !!globalContext?.userAgent?.isWebview
        }).find((route) => matchPath(window.location.pathname, { path: route.path, exact: true }));
        const errorWithData = {
            ...error,
            route: route?.name,
            isMobile: globalContext.userAgent.isMobile,
            isTablet: globalContext.userAgent.isTablet,
            isWebview: globalContext.userAgent.isWebview,
            isInternal: globalContext.isInternal,
            isBot: globalContext.userAgent.isBot,
            isKnownBot: globalContext.isKnownBot
        };
        void clientFetch("/events/grumble", {
            method: "post",
            body: JSON.stringify({
                message: "hydration error on client",
                payload: errorWithData
            }),
            headers: {
                "Content-Type": "application/json",
                "X-Booking-Referrer": window.location.href || ""
            }
        });
    };
}
